import { render, staticRenderFns } from "./OrdersAddendumTable.vue?vue&type=template&id=0abbd7a4&"
import script from "./OrdersAddendumTable.vue?vue&type=script&lang=js&"
export * from "./OrdersAddendumTable.vue?vue&type=script&lang=js&"
import style1 from "./OrdersAddendumTable.vue?vue&type=style&index=1&id=0abbd7a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports